<div class="row m-b-sm">
    <div class="col-xs-4 col-md-4">
        <label>Booking ID</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.bookingNumber}}
    </div>
</div>

<div class="row m-b-sm status-view-edit"
     [ngClass]="{'status-edit-disabled': statusSelectDisabled}"
     (dblclick)="!authService.userIsResident? turnEditMode('status', true) : ''">
    <div class="col-xs-4 col-md-4">
        <label>Status</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText" *ngIf="!statusEditMode">
        <span class="label label-approved"
              *ngIf="amenitiesService.amenityInAmenityModal.status == 'approved'">Approved</span>
        <span class="label label-pending"
              *ngIf="amenitiesService.amenityInAmenityModal.status == 'pending'">Pending</span>
        <span class="label label-expired"
              *ngIf="amenitiesService.amenityInAmenityModal.status == 'expired'">Expired</span>
        <span class="label label-declined"
              *ngIf="amenitiesService.amenityInAmenityModal.status == 'declined'">Declined</span>
        <i (click)="turnEditMode('status', true)"
           *ngIf="!isBookingDateLaterThanCurrent() && !authService.userIsResident && amenitiesService.amenityInAmenityModal.isCanEdit"
           class="fa fa-pencil pull-right" title="Edit"></i>
    </div>

    <div *ngIf="!authService.userIsResident && statusEditMode" class="dv-value-edit col-xs-8 col-md-8">
        <select class="form-control" name="status" [ngModel]="amenitiesService.amenityInAmenityModal.status">
            <option [value]="'approved'">Approved</option>
            <option [value]="'pending'">Pending</option>
            <option [value]="'declined'">Declined</option>
        </select>
        <button type="button"
                [disabled]="disabledSubmit"
                (click)="updateStatus()">
            <i class="fa fa-check"></i></button>
        <button type="button"
                [disabled]="disabledSubmit"
                (click)="turnEditMode('status', false)">
            <i class="fa fa-times"></i></button>
    </div>
</div>

<div class="row m-b-sm" *ngIf="!authService.userIsResident">
    <div class="col-xs-4 col-md-4">
        <label>Building</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.buildingName}}
    </div>
</div>

<div class="row m-b-sm" *ngIf="!authService.userIsResident && !amenitiesService.amenityInAmenityModal.isEvent">
    <div class="col-xs-4 col-md-4">
        <label>Unit</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.suiteNumber}}
    </div>
</div>

<div class="row m-b-sm" *ngIf="!authService.userIsResident && !amenitiesService.amenityInAmenityModal.isEvent">
    <div class="col-xs-4 col-md-4">
        <label>Resident</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.residentFullName}}
    </div>
</div>

<div class="row m-b-sm" *ngIf="!authService.userIsResident && amenitiesService.amenityInAmenityModal.isEvent">
    <div class="col-xs-4 col-md-4">
        <label>Max Participants</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.event.maxNumberOfBookings}}
    </div>
</div>

<div class="row m-b-sm">
    <div class="col-xs-4 col-md-4">
        <label>Uses</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.uses ? amenitiesService.amenityInAmenityModal.uses : '-'}}
    </div>
</div>

<div class="row m-b-sm" *ngIf="amenitiesService.amenityInAmenityModal.managementOverride">
    <div class="col-xs-4 col-md-4">
        <label>Management Override</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        <i class="icon-check"></i>
    </div>
</div>

<div class="row m-b-sm">
    <div class="col-xs-4 col-md-4">
        <label>Time From</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.dateFrom | date:'dd.MM.yyyy hh:mm a':'+0000'}}
    </div>
</div>

<div class="row m-b-sm">
    <div class="col-xs-4 col-md-4">
        <label>Time To</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.dateTo | date:'dd.MM.yyyy hh:mm a':'+0000'}}
    </div>
</div>

<div class="row m-b-sm">
    <div class="col-xs-4 col-md-4">
        <label>Created On</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.createdAt | date:'dd.MM.yyyy hh:mm a'}}
    </div>
</div>

<div class="row m-b-sm">
    <div class="col-xs-4 col-md-4">
        <label>Created By</label>
    </div>
    <div class="col-xs-8 col-md-8 fourteenPixelText">
        {{amenitiesService.amenityInAmenityModal.createdBy}}
    </div>
</div>

<!-- ___ Notes  ___ -->
<div class="row m-b-sm" *ngIf="!authService.userIsResident">
    <div class="col-xs-4 col-md-4">
        <label>Notes</label>
    </div>
    <div class="col-xs-8 col-md-8" *ngIf="amenitiesService.amenityInAmenityModal.isCanEdit">
        <div class="mtv-primary-color" *ngIf="!noteEditMode"
             (click)="turnEditMode('note', true)">+Add Note</div>
        <textarea class="form-control" *ngIf="noteEditMode"
                  name="notes" [(ngModel)]="newNote" maxlength="255" required></textarea>
    </div>
</div>

<div class="row m-b-sm" *ngIf="noteEditMode">
    <div class="col-xs-4 col-md-4"></div>
    <div class="col-xs-8 col-md-8 display-inline">
        <div class="mtv-primary-color" (click)="addNote()" style="width: 50%">Save Note</div>
        <div class="text-align-right mtv-primary-color"
             (click)="turnEditMode('note', false)" style="width: 50%">Cancel</div>
    </div>
</div>

<div class="row m-b-sm" *ngFor="let note of amenitiesService.amenityInAmenityModal.notes">
    <div class="col-xs-4 col-md-4"></div>
    <div class="col-xs-8 col-md-8 notes">
        <pre>{{note.noteText}}</pre>
        <div class="notes-footer">
            <div style="width: 50%">{{note.createdAt | mccDate:true:true}}</div>
            <div class="text-align-right" style="width: 50%">
                {{note.createdBy ? note.createdBy.fullName : ''}}
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenity-info/amenities-info.component.html